import { useContext, useEffect, useState } from 'react';

import AnalyticsContext from 'src/analytics/AnalyticsContext';
import type { RecommendedJobsAnalytics } from 'src/analytics/adapter/recommendedJobs';

import type { mapChaliceJobtoDataLayer } from './mapChaliceJobToDataLayer';

export default function useJobDetailsViewed(
  payload: ReturnType<typeof mapChaliceJobtoDataLayer>,
) {
  const { jobDetailsViewed } = useContext(
    AnalyticsContext,
  ) as RecommendedJobsAnalytics;

  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    if (!tracked) {
      jobDetailsViewed(payload, 'Recommended Jobs (Splitview)');
      setTracked(true);
    }
  }, [jobDetailsViewed, payload, tracked]);
}
